module.exports = __webpack_public_path__ + "static/ring_of_spell_turning-f9b5e32d025222d7774d3007ad8fb069.jpeg";